<template>

    <div class="loading-player">
        <div class="loading-player-bg">
            <div class="circle animation circle-avatar flex-shrink w-114px h-114px"></div>
            <div class="w-138px">
                <div class="pill animation w-100 h-24px"></div>
                <div class="pill animation pill-num flex-shrink mt-1rem"></div>
            </div>
        </div>

        <div class="px-8px">
            <div class="square animation w-100 mb-1rem"></div>
            <div class="square animation w-100 h-256px mb-1rem"></div>
            <div class="square animation w-100 h-158px mb-1rem"></div>
            <div class="square animation w-100 mb-1rem"></div>
            <div class="square animation w-100 h-256px mb-1rem"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingFilter',
        props: {
            type: String
        }
    }
</script>

<style scoped src="../../assets/css/loading/index.css"></style>

<style scoped>
.loading-player {
    /* margin-top: 53.59px; */
    /* padding: 16px 8px; */
    background-color: var(--color-background-default-default) ;
}
.loading-player-bg {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    height: 140px;
    background: linear-gradient(180deg, var(--color-background-default-secondary) 90%, transparent);
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    gap: 16.17px;
}
.circle-avatar {
    /* width: 145px;
    height: 145px; */
}
.pill-num {
    width: 26.83px;
    height: 57.59px;
}
</style>